import { makeAutoObservable, observable } from 'mobx'
import { SelectType } from './models'

type RepublicType = {
	id_republics: number
	republic: string
	AVN_user: number
	AVN_update: number
	visible: number
	RS: number
	republic_okno: string
}

type OblastType = {
	id_oblast: number
	id_republics: number
	oblast: string
	oblast_kg: string
}

type RaionType = {
	id_raion: number
	id_republics: number
	id_oblast: number
	raion: string
	raion_kg: string
}

class Places {
	republic: SelectType[] = []
	oblast: SelectType[] = []
	raion: SelectType[] = []

	constructor() {
		makeAutoObservable(this, {
			republic: observable,
			oblast: observable,
			raion: observable
		})
	}

	newRepublic(param: SelectType[]) {
		this.republic = param
	}
	newOblast(param: SelectType[]) {
		this.oblast = param
	}
	newRaion(param: SelectType[]) {
		this.raion = param
	}
}

export const places = new Places()
